import urls from "@/api/url";
import $config from "@/config/baseConfig";
// import jWeixin from "weixin-js-sdk";
import { cache } from "@/utils/common";

export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  destroyed() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    onPayPageInitBefore() {
      return new Promise((resolve, reject) => {
        let isPay = cache.get("isPay");
        cache.set("isPay", "empty");
        if (isPay == "pay") {
          this.onSubmitPayAfter();
          reject();
        } else {
          resolve();
        }
      });
    },
    onWeChatPayBefore(options) {
      return new Promise((resolve, reject) => {
        if (jWeixin && jWeixin.miniProgram && jWeixin.miniProgram.getEnv) {
          jWeixin.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              this.onWeChatApplet(options);
              reject();
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    },
    onWeChatApplet(options = {}) {
      let that = this;
      let user = cache.get("user");
      let url =
        `/pages1/pay/Pay?api=${$config.serverUrl +
          urls.Pay_Wechat}&data=${JSON.stringify(options)}&token=${
          user.token
        }&path=` + that.$route.fullPath;
      jWeixin.miniProgram.navigateTo({
        url
      });
    },
    onWeChatAppPaySubmit() {
      this.onSubmitPayAfter();
    }
  }
};
